"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _polished = require("polished");

var getCustomStyles = function getCustomStyles(_ref) {
  var fontFamily = _ref.fontFamily,
      backgroundColor = _ref.backgroundColor,
      backgroundColorDisabled = _ref.backgroundColorDisabled,
      borderColor = _ref.borderColor,
      borderColorFocus = _ref.borderColorFocus,
      borderColorError = _ref.borderColorError,
      borderColorDisabled = _ref.borderColorDisabled,
      dropdownIndicatorColor = _ref.dropdownIndicatorColor,
      dropdownIndicatorColorDisabled = _ref.dropdownIndicatorColorDisabled,
      indicatorsContainerPaddingHorizontal = _ref.indicatorsContainerPaddingHorizontal,
      inputBoxSizeDefault = _ref.inputBoxSizeDefault,
      inputBoxSizeSmall = _ref.inputBoxSizeSmall,
      inputColor = _ref.inputColor,
      menuBackgroundColor = _ref.menuBackgroundColor,
      menuBorderSize = _ref.menuBorderSize,
      menuBorderColor = _ref.menuBorderColor,
      menuBoxShadowColor = _ref.menuBoxShadowColor,
      menuBoxShadowSize = _ref.menuBoxShadowSize,
      menuBorderStyle = _ref.menuBorderStyle,
      menuZindex = _ref.menuZindex,
      optionActiveBackgroundColor = _ref.optionActiveBackgroundColor,
      optionHoveredBackgroundColor = _ref.optionHoveredBackgroundColor,
      optionPaddingHorizontal = _ref.optionPaddingHorizontal,
      optionPaddingVertical = _ref.optionPaddingVertical,
      optionTextFontSize = _ref.optionTextFontSize,
      optionTextFontWeightSelected = _ref.optionTextFontWeightSelected,
      optionTextColor = _ref.optionTextColor,
      optionTextSelectedColor = _ref.optionTextSelectedColor,
      noOptionTextColor = _ref.noOptionTextColor,
      noOptionTextFontSize = _ref.noOptionTextFontSize,
      placeholderTextColor = _ref.placeholderTextColor,
      selectedOptionTextColor = _ref.selectedOptionTextColor,
      valueContainerPadding = _ref.valueContainerPadding,
      headingTextFontSize = _ref.headingTextFontSize,
      headingTextFontWeight = _ref.headingTextFontWeight,
      headingTextColor = _ref.headingTextColor,
      headingBorderSize = _ref.headingBorderSize,
      headingBorderStyle = _ref.headingBorderStyle,
      headingBorderColor = _ref.headingBorderColor,
      headingPadding = _ref.headingPadding,
      headingMargin = _ref.headingMargin,
      controlFocusBoxShadow = _ref.controlFocusBoxShadow;

  var getOptionTextStyles = function getOptionTextStyles(isSelected) {
    if (isSelected) {
      return {
        color: optionTextSelectedColor,
        fontWeight: optionTextFontWeightSelected
      };
    }

    return {
      color: optionTextColor
    };
  };

  var getBorderColor = function getBorderColor(_ref2) {
    var isDisabled = _ref2.isDisabled,
        isFocused = _ref2.isFocused,
        hasError = _ref2.hasError;

    if (isDisabled) {
      return borderColorDisabled;
    }

    if (hasError) {
      return borderColorError;
    }

    if (isFocused) {
      return borderColorFocus;
    }

    return borderColor;
  };

  return {
    control: function control(providedStyle, _ref3) {
      var isDisabled = _ref3.isDisabled,
          isFocused = _ref3.isFocused,
          _ref3$selectProps = _ref3.selectProps,
          size = _ref3$selectProps.size,
          hasError = _ref3$selectProps.hasError;
      return Object.assign({}, providedStyle, {
        '&:hover': undefined,
        borderColor: getBorderColor({
          isDisabled: isDisabled,
          isFocused: isFocused,
          hasError: hasError
        }),
        background: isDisabled ? backgroundColorDisabled : backgroundColor,
        height: size === 'default' ? inputBoxSizeDefault : inputBoxSizeSmall,
        boxShadow: isFocused ? controlFocusBoxShadow : undefined,
        cursor: !isDisabled && !isFocused && 'pointer'
      });
    },
    dropdownIndicator: function dropdownIndicator(providedStyle, _ref4) {
      var isDisabled = _ref4.isDisabled;
      return Object.assign({}, providedStyle, {
        color: isDisabled ? dropdownIndicatorColorDisabled : dropdownIndicatorColor
      });
    },
    groupHeading: function groupHeading(providedStyle) {
      return Object.assign({}, providedStyle, (0, _polished.ellipsis)(), {
        fontFamily: fontFamily,
        fontSize: headingTextFontSize,
        fontWeight: headingTextFontWeight,
        textAlign: 'initial',
        textTransform: undefined,
        color: headingTextColor,
        display: 'block',
        borderBottom: "".concat(headingBorderSize, " ").concat(headingBorderStyle, " ").concat(headingBorderColor),
        padding: headingPadding,
        margin: headingMargin
      });
    },
    indicatorSeparator: function indicatorSeparator(providedStyle) {
      return Object.assign({}, providedStyle, {
        display: 'none'
      });
    },
    indicatorsContainer: function indicatorsContainer(providedStyle) {
      return Object.assign({}, providedStyle, {
        padding: "0 ".concat(indicatorsContainerPaddingHorizontal)
      });
    },
    input: function input(providedStyle) {
      return Object.assign({}, providedStyle, {
        color: inputColor
      });
    },
    menu: function menu(providedStyle) {
      return Object.assign({}, providedStyle, {
        boxShadow: "".concat(menuBoxShadowSize, " ").concat(menuBoxShadowColor),
        background: menuBackgroundColor,
        border: "".concat(menuBorderSize, " ").concat(menuBorderStyle, " ").concat(menuBorderColor),
        zIndex: "".concat(menuZindex)
      });
    },
    noOptionsMessage: function noOptionsMessage(providedStyle) {
      return Object.assign({}, providedStyle, {
        fontFamily: fontFamily,
        fontSize: noOptionTextFontSize,
        padding: "".concat(optionPaddingVertical, " ").concat(optionPaddingHorizontal),
        color: noOptionTextColor
      });
    },
    option: function option(providedStyle, state) {
      var isFocused = state.isFocused,
          isSelected = state.isSelected,
          isDisabled = state.isDisabled;
      return Object.assign({}, providedStyle, {
        fontFamily: fontFamily,
        fontSize: optionTextFontSize,
        position: 'relative',
        padding: "".concat(optionPaddingVertical, " ").concat(optionPaddingHorizontal),
        display: 'flex',
        textAlign: 'initial',
        color: optionTextColor,
        background: isFocused || isSelected ? optionHoveredBackgroundColor : 'transparent'
      }, getOptionTextStyles(isSelected), {
        ':active': {
          background: optionActiveBackgroundColor
        },
        opacity: isDisabled ? 0.5 : undefined,
        cursor: isDisabled ? 'default' : 'pointer'
      });
    },
    placeholder: function placeholder(providedStyle, _ref5) {
      var isSearchable = _ref5.selectProps.isSearchable;
      return Object.assign({}, providedStyle, {
        fontSize: optionTextFontSize,
        color: placeholderTextColor,
        top: 0,
        transform: 0,
        position: isSearchable ? 'absolute' : 'relative'
      });
    },
    singleValue: function singleValue(providedStyle, _ref6) {
      var isSearchable = _ref6.selectProps.isSearchable;
      return Object.assign({}, providedStyle, {
        color: selectedOptionTextColor,
        top: 0,
        transform: 0,
        position: isSearchable ? 'absolute' : 'relative'
      });
    },
    valueContainer: function valueContainer(providedStyle) {
      return Object.assign({}, providedStyle, (0, _polished.ellipsis)(), {
        padding: "0 ".concat(valueContainerPadding),
        display: 'flex',
        flexWrap: 'nowrap'
      });
    }
  };
};

var _default = getCustomStyles;
exports["default"] = _default;